<template>
    <div class="h-full">
        <ai-grid-edit v-if="isDataLoaded" ref="gridRef" :meta="meta" :args="args" />
    </div>
</template>

<script setup>
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { onMounted, ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
//import { getOkvedRazdel, getOkveds } from '@/service/counteragent-service';

const gridRef = ref();

const isDataLoaded = ref(false);
/*const razdel = ref([]);
const razdelComp = computed(() => razdel.value);*/
/*const okved = ref([]);
const okvedComp = computed(() => okved.value);*/
const refreshDicts = async () => {
    /*const data = await getOkvedRazdel();
    if (data && data.result) {
        razdel.value = data.data;
    }*/
    /*const data2 = await getOkveds();
    if (data2 && data2.result) {
        okved.value = data2.data;
    }*/
};

onMounted(async () => {
    await refreshDicts();
    isDataLoaded.value = true;
});

const route = useRoute();

const meta = reactive({
    keyExpr: 'id',
    viewId: 'WidgetPayerDopOkved',
    focusedRowEnabled: true,
    api: {
        select: 'counteragent./customer/card/widget/dop-okved/get',
        //save: 'counteragent./customer/card/widget/notebook/save'
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        /*{
            dataField: 'okved',
            caption: 'ОКВЭД',
            dataType: 'string',
            width: 150,
        },*/
        {
            dataField: 'kod_okved',
            caption: 'Наименование ОКВЭД',
            width: 200,
            dataType: 'number',
            editor: { type: 'ai-drop-down', text: 'name_okved' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text: 'name_okved',
                meta: {
                    keyExpr: 'id',
                    columns: [
                        { caption: 'kod_okved', visible: false, dataField: 'id' },
                        { caption: 'Раздел', dataField: 'name_razdel' },
                        { caption: 'ОКВЭД', dataField: 'okved' },
                        { caption: 'Наименование', dataField: 'name_okved' },
                    ],
                    api: { select: 'meta./meta/ai-grid-ro-select/get' },
                },
                args: {
                    meta_args: { select: 'payer.hf_get_dictionary' },
                    select_args: {
                        schema: 'payer',
                        table: 'kv_okved',
                        where: 'true',
                        order: 'name_razdel, name_okved',
                    },
                },
            },
        },
        /*{
            dataField: 'kod_razd',
            caption: 'Раздел',
            width: 200,
            dataType: 'number',
            editor: { type: 'ai-drop-down', text: 'name_razdel' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text:'name',
                meta: {
                    keyExpr: 'kod_okved',
                    columns: [{caption: 'kod_okved', visible: false, dataField: 'kod_okved'}, {caption: 'Раздел ОКВЭД', dataField: 'name'}],
                    api: {select: 'meta./meta/ai-grid-ro-select/get'},
                },
                args: {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'payer', table: 'ks_okved', where: 'kod_res_okved = 1 and kod_razd is null', order: 'name'}},
            },
        },*/
    ],
});

const args = { select: { kodp: route.params.id }, save: { kodp: route.params.id } };
</script>
